import React from 'react';
import { Link } from 'react-router-dom';
import { SupportContact } from './SupportContact';

export function ProviderFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="provider-footer">
      <div className="provider-footer-inner">
        <p className="provider-footer-copy">© {year} ReTechSys. All rights reserved.</p>
        <nav className="provider-footer-nav" aria-label="Legal">
          <Link to="/provider/terms">Terms</Link>
          <Link to="/provider/privacy">Privacy Policy</Link>
          <Link to="/provider/cookies">Cookie Policy</Link>
          <SupportContact variant="link" triggerLabel="Support" triggerClassName="provider-footer-support" />
        </nav>
      </div>
    </footer>
  );
}

export default ProviderFooter;
